import { FuseSplashScreen } from "@fuse";
import _ from "@lodash";
import { CircularProgress, TextField, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import FirebaseAuthService from "app/Core/services/FirebaseAuthService";
import * as AppActions from "app/store/actions";
import clsx from "clsx";
import Constante from "Constante.json";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { Link, withRouter } from "react-router-dom";
import { load } from "recaptcha-v3";
import { bindActionCreators } from "redux";

const styles = theme => ({
    fontColor: {
        color: theme.palette.type === "dark" ? "#C7C7C7" : "#757575",
        textDecoration: "none",
        "&:hover": {
            color: theme.palette.type === "dark" ? "#C7C7C7" : "#757575"
        }
    }
});

class LoginFirebase extends XAPPComponent {

    state = {
        showReenviar: false,
        username: "",
        password: "",
        recaptcha: "",
        disabled: false,
    };

    componentDidMount() {
        load(Constante.chave_recaptcha).then((recaptcha) => {
            recaptcha.execute("login").then((token) => {
                this.setState(_.set({ ...this.state }, "recaptcha", token));
            });
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.disabled && !prevState.disabled) {
            window.setTimeout(() => this.setDisabled(), 5000);
        }
    }

    isFormValid = () => {
        const form = this.state;
        return (form.username.length > 0 && form.username.includes("@") && form.password.length > 5 && form.recaptcha.length > 0);
    };

    setDisabled = (_AValue = false) => {
        this.setState(_.set({ ...this.state }, "disabled", _AValue));
    };

    setSubmit = (_AValue) => {
        this.setState({ btnSubmited: _AValue });
    };

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    handleSubmit = () => {
        const { lockUser = false } = this.props;
        const model = this.state;
        if (model.disabled) {
            return;
        }

        if (lockUser && !_.isUndefined(sessionStorage.getItem("login")) && !_.isNull(sessionStorage.getItem("login"))) {
            model.username = sessionStorage.getItem("login");
        }

        this.setDisabled(true);
        model.username = String(model.username).trim();
        model.password = String(model.password).trim();

        FirebaseAuthService.Login(model)
            .then(() => {
                if (lockUser) {
                    FirebaseAuthService.signInWithFirebase();
                }
                sessionStorage.setItem("login", model.username);
                this.props.callback();
            })
            .catch((erro) => {
                if (erro.message.includes("Email não verificado")) {
                    this.setState({ showReenviar: true });
                }
                if (_.isObject(erro) && erro.variant) {
                    this.props.showMessage(erro);
                    this.setSubmit(false);
                }
            });


    };

    Reenviar = () => {
        FirebaseAuthService.ReenviarEmail()
            .then((resp) => {
                this.props.showMessage(resp);
            });
    };

    render() {
        const form = this.state;
        const { classes } = this.props;
        return (
            <React.Fragment>
                <div className="w-full">
                    <TextField
                        className="mb-16"
                        label="Email"
                        type="email"
                        name="username"
                        key="username"

                        value={form.email}
                        onChange={this.handleChange}
                        variant="outlined"
                        required
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        className="mb-16"
                        label="Senha"
                        type="password"
                        name="password"
                        key="password"
                        value={form.password}
                        onChange={this.handleChange}
                        variant="outlined"
                        required
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <div className="flex">
                        <Link id="link-esqueci-senha" className={clsx(classes.fontColor, "font-medium cursor-pointer justify-center")} to="/pub-reset-password">Esqueci minha senha</Link>
                    </div>
                    <div className="flex">
                        {form.showReenviar &&
                            <Link id="link-solicitar-email" className={clsx(classes.fontColor, "font-medium cursor-pointer justify-center")} onClick={() => this.Reenviar()}>Solicitar verificação de email</Link>
                        }
                    </div>
                    {form.recaptcha.length < 1 &&
                        <div className="flex w-full items-center justify-center gap-4 my-8">
                            <CircularProgress size={"20px"} className="m-4" color="none" />
                            Aguardando reCAPTCHA...
                        </div>
                    }
                    <XAPPButton
                        id="btn-login"
                        type="button"
                        variant="contained"
                        color="primary"
                        className="w-full mx-auto normal-case mt-12"
                        aria-label="LOG IN"
                        value="firebase"
                        disabled={!this.isFormValid()}
                        onClick={() => this.handleSubmit()}
                    >
                        ENTRAR
                    </XAPPButton>
                </div>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        showMessage: AppActions.showMessage,
    }, dispatch);
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(null, mapDispatchToProps)(LoginFirebase)));
